import { render, staticRenderFns } from "./AvatarAction.vue?vue&type=template&id=93dc8924&"
import script from "./AvatarAction.vue?vue&type=script&lang=js&"
export * from "./AvatarAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports